import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import useSWR from 'swr';

import { PageHeader } from '../../../components/PageHeader';
import { GoogleAuthButton } from '../components/GoogleAuthButton';
import { getMe } from '../models';
import { SpinnerBlock } from '../../../components/Spinner';

export const InternalLoginPage = () => {
  const navigate = useNavigate();
  const { data: me, isLoading } = useSWR('auth/me', getMe, {
    revalidateOnFocus: false,
  });

  useEffect(() => {
    if (me) {
      navigate('/internal', { replace: true });
    }
  }, [me, navigate]);

  // Show loading spinner while checking authentication
  if (isLoading) {
    return <SpinnerBlock message="Loading..." />;
  }

  // eslint-disable-next-line no-restricted-globals
  const redirectUri = window.location.origin;
  return (
    <>
      <PageHeader title="Interne Login" />

      <main className="p-8 min-h-screen w-full">
        <div className="flex flex-col justify-center h-full items-center mx-auto max-w-lg">
          <img className="w-64 mt-16 mb-16" src="/static/logo-dark.svg" />

          <div className="w-full flex">
            <GoogleAuthButton redirectUri={redirectUri} />
          </div>
        </div>
      </main>
    </>
  );
};
